import gql from 'graphql-tag';

const FRAGMENT = gql`
  fragment Contact on user_contacts {
    id
    email
    phone  
    first_name
    last_name
    photo
    invited
    suggested
    source
    external_id
  }
`;

export const GET_CONTACTS = gql`
  query getContacts(
    $search: String
    $offset: Int
    $limit: Int
  ) {
    rows: user_contacts(
      where: {
        _or: [
          { first_name: { _ilike: $search } }
          { last_name: { _ilike: $search } }
          { email: { _ilike: $search } }
        ]
      }
      limit: $limit
      offset: $offset
      order_by: [{relevance: desc}, {suggested: asc}, { first_name: asc}]
    ) {
      ...Contact
    }
    count: user_contacts_aggregate(
      where: {
        _or: [
          { first_name: { _ilike: $search } }
          { last_name: { _ilike: $search } }
          { email: { _ilike: $search } }
        ]
      }
    ) {
      aggregate {
        count
      }
    }
  }
  ${FRAGMENT}
`;

export const GET_PENDING_INVITES = gql`
  query getPendingContacts(
    $search: String
    $offset: Int
    $limit: Int
  ) {
    rows: user_contacts(
      where: {
        invited: { _eq: true }
        claimed_user_id: { _is_null: true }
        _or: [
          { first_name: { _ilike: $search } }
          { last_name: { _ilike: $search } }
          { email: { _ilike: $search } }
        ]
      }
      limit: $limit
      offset: $offset
      order_by: [{first_name: asc }]
    ) {
      ...Contact
    }
    count: user_contacts_aggregate(
      where: {
        invited: { _eq: true }
        claimed_user_id: { _is_null: true }
        _or: [
          { first_name: { _ilike: $search } }
          { last_name: { _ilike: $search } }
          { email: { _ilike: $search } }
        ]
      }
    ) {
      aggregate {
        count
      }
    }
  }
  ${FRAGMENT}
`;

export const UPDATE_CONTACT = gql`
  mutation updateContact($id: Int!, $data: user_contacts_set_input!) {
    update_user_contacts_by_pk(pk_columns: { id: $id }, _set: $data) {
      ...Contact
    }
  }
  ${FRAGMENT}
`;

export const UPDATE_SUGGESTED = gql`
    mutation updateSuggestedCount($ids: [Int!]!) {
        update_user_contacts(where: { id: {_in: $ids}}, _inc: {suggested: 1 }) {
            affected_rows
        }
    }
`;

export const INSERT_CONTACTS = gql`
    mutation insertContacts($data: [user_contacts_insert_input!]!) {
        rows: insert_user_contacts(objects: $data, on_conflict: {
            constraint: user_contacts_source_external_id_user_id_key,
            update_columns: [email,first_name]
        }) {
            returning {
                id
                email
                phone
                first_name
            }
        }
    }
`;